<template>
  <!-- Spinner -->
  <!-- Linear and Circular -->
  <!-- Determinate and indeterminate -->
  <div 
    class="fts-spinner" 
    :class="{'full-screen-fixed': fullScreen}" 
    :style="spinnerStyle"
    v-if="show">
    <svg class="spinner" viewBox="25 25 50 50" :style="iconSize">
      <circle class="path" fill="none" stroke-width="3" stroke-miterlimit="10" cx="50" cy="50" r="20"></circle>
    </svg>
  </div>
</template>

<script>

let resizeObserver = null;

export default {
  props: {
    show: Boolean,
    height: String,
    width: String,
    size: {
      type: Number,
      default: 50
    },
    fullScreen: Boolean,  
    boundary: {
      type: String,
      validator: value => ['parent'].indexOf(value) > -1
    },
  },
  data: () => ({
    parentOffset: null,
  }),
  computed: {
    spinnerStyle() {
      if (this.fullScreen) {
        if (this.boundary === 'parent' && this.parentOffset)
          return {
            width: `${this.parentOffset.offsetWidth}px`,
          }
        else if (this.boundary !== 'parent')
          return {
            left: 0,
            right: 0,
            bottom: 0,
          }
      }
    },
    iconSize() {
      return {
        height: `${this.size}px`,
        width: `${this.size}px`,
      }
    },
  },
  mounted() {
    if (this.fullScreen && this.boundary === 'parent') {
      resizeObserver = new ResizeObserver(_.debounce((entries) => {
        this.parentOffset = {
          offsetWidth: entries[0].target.offsetWidth,
        }
        // console.info("parentOffset", this.parentOffset.offsetWidth);
      }));

      this.$nextTick(() => {
        resizeObserver.observe(this.$el.parentElement);
      }, 50);
    }
  },
  beforeDestroy() {
    if (this.fullScreen && this.boundary === 'parent') {
      resizeObserver.unobserve(this.$el.parentElement);
      this.parentOffset = null;
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./src/assets/scss/vars.scss";

.fts-spinner {
  @include flex-center-middle;
  flex-direction: column;
  &.full-screen-fixed {
    position: fixed;
    height: 100%;
    width: 100%;
    top: 0;
  }
  .spinner {
    $duration: 2s;
    @keyframes rotate {
      100% {
        transform: rotate(360deg);
      }
    }
    @keyframes color {
      100%, 0% {
        stroke: $primaryColor;
      }
      40% {
        stroke: $ternaryBlueColor;
      }
      66% {
        stroke: $ternaryGreenColor;
      }
      80%, 90% {
        stroke: $ternaryBlueColor;
      }
    }
    @keyframes dash {
      0% {
        stroke-dasharray: 1, 200;
        stroke-dashoffset: 0;
      }
      50% {
        stroke-dasharray: 89, 200;
        stroke-dashoffset: -35px;
      }
      100% {
        stroke-dasharray: 89, 200;
        stroke-dashoffset: -124px;
      }
    }
    animation: rotate $duration linear infinite;
    .path {
      stroke-dasharray: 1, 200;
      stroke-dashoffset: 0;
      animation: dash 1.5s ease-in-out infinite, color 6s ease-in-out infinite;
      stroke-linecap: round;
    }
  }
}
</style>